<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goBack()">返回</el-button>
    <div style="padding-top: 20px"></div>
    <el-card>
      <div class="topbar">
        <div/>
        <el-button type="primary" size="small" @click="updateAdminQuestion">保存</el-button>
      </div>

      <el-form :model="questionDetail" ref="addQuestionFormRef">
        <el-form-item label="关联目录" prop="parentId"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]" label-width="90px">
          <el-select v-model="questionDetail.parentId">
            <el-option :value="0" label="添加为目录" :key="0"></el-option>
            <el-option v-for="item in parentQuestion" :value="item.questionId" :key="item.questionId"
                       :label="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
                      label-width="90px">
          <el-input v-model="questionDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="答案" prop="answer" label-width="90px">
          <el-input v-model="questionDetail.answer"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort" label-width="90px">
          <el-input-number v-model="questionDetail.sort"></el-input-number>
        </el-form-item>
        <el-form-item label="常问问题" prop="often" label-width="90px">
          <el-switch :active-value="1" active-text="是" :inactive-value="0" inactive-text="否"
                     v-model="questionDetail.often"></el-switch>
        </el-form-item>
        <div v-if="questionDetail.parentId !== 0">
          <el-form-item label="图片/视频" label-width="90px">
            <div class="topbar">
              <div/>
              <el-upload
                  ref="uploadCoverRef"
                  style="float: right"
                  :http-request="uploadFile"
                  action=""
                  accept=".jpg,.png,.mp4,.pdf"
                  show-file-list:false
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-change="onChange"
                  :on-remove="onRemove"
                  :file-list="uploadFileList"
                  :before-upload="beforeUpload"
                  :auto-upload="true"
              >
                <div>
                  <video id="upvideo" v-if="uploadVideoFileURL !== null" :src="uploadVideoFileURL " controls
                         style="width: 100%;height: 30vh;overflow: auto;"/>
                  <br/>
                  <el-button slot="trigger" style="margin-bottom: 3px" size="small" type="primary">
                    上传文件
                  </el-button>
                </div>

              </el-upload>
            </div>
          </el-form-item>
          <el-table :data="questionDetail.fileList" :header-cell-style="{ background: '#F5F7FA' }"
                    style="margin-bottom: 20px" border>
            <el-table-column label="#" prop="questionFileId" align="center"></el-table-column>
            <el-table-column label="文件" align="center">
              <template #default="scope">
                <div v-if="scope.row.fileType === 1 || scope.row.fileType === 0"
                     style="width: 100px; height: 100px;position: relative">
                  <el-image style="width: 100px; height: 100px;" fit="scale-down"
                            :src="getPreviewImageUrl(scope.row)" lazy
                            :preview-src-list="[getPreviewImageUrl(scope.row)]"
                            :close-on-click-modal="true">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <i class="el-icon-video-play"
                     v-if="scope.row.fileType === 1"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                     @click.stop="previewVideo(scope.row.fileUrl)"></i>
                </div>
                <div v-else>
                  <el-button type="text" @click="previewPDF(scope.row)">{{ scope.row.fileShowName }}</el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="上传时间" prop="createTime" align="center">
              <template #default="scope">
                {{ scope.row.createTime | formatDateTime }}
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template #default="scope">
                <el-button size="small" :type="scope.row.deleted ? 'warning' : 'danger'"
                           @click="handleDeleteFile(scope.row)">
                  {{ scope.row.deleted ? '恢复' : '删除' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div>
          <el-form-item label="子问题列表" label-width="90px">

          </el-form-item>
          <el-table :data="questionDetail.childQuestionList" :header-cell-style="{ background: '#F5F7FA' }"
                    style="margin-bottom: 20px" border>
            <el-table-column type="expand">
              <template #default="scope">
                <div v-if="scope.row.parentId">
                  <p>关联目录：{{ scope.row.parentTitle }}</p>
                </div>
                <div v-if="scope.row.childQuestionList">
                  <p>关联子问题数：{{ scope.row.childQuestionList.length }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="#" prop="questionId" align="center"></el-table-column>
            <el-table-column label="标题" prop="title" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="答案" prop="answer" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="常问问题" prop="often" align="center">
              <template #default="scope">
                {{ scope.row.often === 0 ? '否' : '是' }}
              </template>
            </el-table-column>
            <!--      <el-table-column label="提交者" prop="title" align="center">-->
            <!--        <template #default="scope">-->
            <!--          <user-info :user="scope.row"></user-info>-->
            <!--        </template>-->
            <!--      </el-table-column>-->
            <el-table-column label="提交时间" prop="createTime" align="center">
              <template #default="scope">
                {{ scope.row.createTime | formatDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="删除时间" prop="createTime" align="center">
              <template #default="scope">
                {{ scope.row.deleteTime | formatDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="scope">
                <el-button size="small" type="primary" @click="go2QuestionDetail(scope.row)">编辑</el-button>
                <el-button size="small" :type="scope.row.deleted ? 'warning':'danger'" @click="handleDelete(scope.row)">
                  {{ scope.row.deleted ? '恢复' : '删除' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-form>
    </el-card>

    <el-dialog :visible.sync="previewVideoDlg" :destroy-on-close="true">
      <tx-video-player style="height: 60vh;" :video-url="previewVideoUrl"></tx-video-player>
    </el-dialog>

    <el-dialog :visible.sync="previewPDFDlg">
      <embed :src="this.previewPDFUrl" style="width: 100%; height: 700px"/>
    </el-dialog>

    <canvas id="mycanvas" style="display: none"></canvas>
  </div>
</template>

<script>
import {
  getAdminQuestionOne,
  updateAdminQuestion,
  addAdminQuestionFile,
  getAdminQuestionList,
  deleteAdminQuestionOrBack, deleteAdminQuestionFileOrBack
} from "@/api/system/AdminQuestion/AdminQuestion";
import {handleRes} from "@/utils/handleRes";
import {
  isVaild
} from "@/utils/validate";
import {getCloudUrl, getLocalFileURL, getPreviewImgUrl} from "@/utils/urlutil";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {getVideoCover, getVideoDuration} from "@/utils/videoUtils";

export default {
  name: "AdminQuestionDetail",
  components: {TxVideoPlayer},
  created() {
    let queryId = this.$route.query.questionId
    if (isVaild(queryId)) {
      this.questionId = queryId
      this.getAdminQuestionOne()
    }
    this.getParentQuestionList()
  },
  data() {
    return {
      questionId: -1,
      questionDetail: {},
      parentQuestion: [],

      previewVideoDlg: false,
      previewVideoUrl: "",
      uploadFileList: [],
      videoCover: null,//视频封面
      uploadVideoFileURL: null,
      uploadVideoFile: null,
      uploadVideoTimeLength: 0,

      previewPDFDlg: false,
      previewPDFUrl: ""
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getParentQuestionList() {
      getAdminQuestionList({
        parentId: 0,
        pageSize: 0
      }).then(res => {
        handleRes(res, () => {
          this.parentQuestion = res.data.rows
        })
      })
    },
    getAdminQuestionOne() {
      getAdminQuestionOne({
        questionId: this.questionId
      }).then(res => {
        handleRes(res, () => {
          this.questionDetail = res.data
        })
      })
    },
    updateAdminQuestion() {
      updateAdminQuestion(this.questionDetail).then(res => {
        handleRes(res, () => {
          this.$message('操作成功')
          this.getAdminQuestionOne()
        })
      })
    },
    getPreviewImageUrl(entity) {
      return getPreviewImgUrl(entity)
    },
    previewVideo(fileUrl) {
      this.previewVideoUrl = getCloudUrl(fileUrl)
      this.previewVideoDlg = true
    },
    go2QuestionDetail(entity) {
      this.$router.push({
        path: "adminQuestionDetail",
        query: {
          questionId: entity.questionId
        }
      })
    },
    handleDelete(entity) {
      deleteAdminQuestionOrBack({
        questionId: entity.questionId
      }).then(res => {
        handleRes(res, () => {
          this.$message('操作成功')
          this.getAdminQuestionOne()
        })
      })
    },
    /**
     * 上传数量限制提示
     */
    handleExceed() {
      this.$message({
        message: "一次只能上传一个文件",
        type: "warning",
      });
    },
    /**
     * 监听上传文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    async onChange(file, fileList) {
      this.resetUploadInfo();
      this.uploadFileList = fileList;
      this.uploadVideoFile = file;
    },
    /**
     * 监听移除文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onRemove(file, fileList) {
      this.uploadFileList = fileList;
      this.resetUploadInfo();
    },
    resetUploadInfo() {
      this.videoCover = null;
      this.uploadVideoFileURL = null
      this.uploadVideoFile = null
    },
    /**
     * 上传限制校验
     *
     * @param {object} file 文件对象
     */
    beforeUpload(file) {
      // 文件类型限制
      let exname = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
      const fileTypes = ["mp4", "jpg", "png", "pdf"];
      var index = fileTypes.indexOf(exname)
      if (index < 0) {
        this.$message({
          message: "上传文件只能是 MP4 / JPG / PNG / PDF 格式",
          type: "warning",
        });
        return false;
      }
    },
    /**
     * 延时，保证视频加载完，可以拿到视频cover
     * @param url
     * @returns {Promise<unknown>}
     */
    getVideoDuration(url) {

      return getVideoDuration(url)
    },
    getVideoCover(url) {
      return getVideoCover(document.getElementById("upvideo"), document.getElementById("mycanvas"), url)

    },
    async uploadFile(file) {
      const uploadFile = file.file; // 获取上传的file对象

      let uploadParam = {}
      uploadParam.questionId = this.questionId
      let uploadFileSuffix = uploadFile.name.toLowerCase().substring(uploadFile.name.lastIndexOf("."))
      if (uploadFileSuffix === ".mp4") {
        this.uploadVideoFileURL = getLocalFileURL(this.uploadVideoFile)
        let duration = await this.getVideoDuration(this.uploadVideoFileURL);
        this.uploadVideoTimeLength = duration / 1000;
        // console.log("upload video time length " + duration)
        this.videoCover = await this.getVideoCover(this.uploadVideoFileURL)
        uploadParam.fileType = 1
      } else if (uploadFileSuffix === ".pdf") {
        uploadParam.fileType = 2
      } else {
        uploadParam.fileType = 0
      }
      uploadParam.fileShowName = uploadFile.name

      let savepathParamsRes = await getOSSUploadInfo({
        DataType: "30",
        ID: "0",
      });
      if (!isVaild(savepathParamsRes)) {
        return;
      }
      let savePathParams = savepathParamsRes.resultData


      var uploadRes;
      let fileName;
      //上传封面
      if (isVaild(this.videoCover)) {
        // console.log(this.videoCover)
        // printObj(this.uploadCoverFile.raw)
        let timestamp = new Date().valueOf();
        var str = this.videoCover.split(",");
        var suffix = this.videoCover.split(";")[0].split("/")[1];
        console.log("IMG-Suffix====>>", suffix)
        fileName = savePathParams.PicSavePath + "cover_from_video_" +
            timestamp + "." + suffix;
        // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

        //base64
        var buffer = Buffer.from(str[1], 'base64');
        uploadRes = await uploadFile2OSS(savePathParams, buffer, fileName)
        if (uploadRes.status === 0) {
          uploadParam.faceUrl = "/" + fileName
          uploadParam.videoLen = this.uploadVideoTimeLength
          // console.log(this.form.liveCover)
        } else {
          this.$message({
            type: "error",
            message: "上传失败"
          })
        }
      }
      //上传文件
      let timestamp = new Date().valueOf();
      fileName = savePathParams.PicSavePath + timestamp + uploadFile.name.substring(uploadFile.name.lastIndexOf("."));
      uploadRes = await uploadFile2OSS(savePathParams, uploadFile, fileName)
      if (uploadRes.status === 0) {
        uploadParam.fileSize = uploadFile.size
        uploadParam.fileUrl = "/" + fileName
        this.$refs.uploadCoverRef.clearFiles();
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        })
        return
      }

      addAdminQuestionFile(uploadParam).then((res) => {
        handleRes(res, () => {
          this.getAdminQuestionOne()
        })
      });
    },

    handleDeleteFile(entity) {
      deleteAdminQuestionFileOrBack({
        questionFileId: entity.questionFileId
      }).then(res => {
        handleRes(res, () => {
          this.$message.info('操作成功')
          this.getAdminQuestionOne()
        })
      })
    },
    previewPDF(entity) {
      // this.previewPDFDlg = true;
      // this.previewPDFUrl = entity.fileUrl
      window.open(getCloudUrl(entity.fileUrl))
    }
  }
}
</script>

<style scoped>

</style>